"use client";

import React from "react";
import styles from "./StripData.module.scss";
import dayjs from "dayjs";
import { getGlobalStateValue, updateStateSession } from "@/context/utils";

import { useContext } from "react";
import { ModalContext } from "@/context/ModalContext";
import { IModalActions, ModalTypes } from "@/types/modal";
import { pushToDataLayer } from "@/helpers/gtag";


const StripDataNew = ({ htmlContent, lastRegistrationDate,associatedPrograms, isScrollable = false ,isScrollableID= "" }) => {
  const { modalDispatch } = useContext(ModalContext);
  if(!htmlContent) 
    return null
 
  const calcHours = Math.floor(dayjs(lastRegistrationDate).diff(dayjs().format('YYYY-MM-DD'), "hours") / 24) + 1;
  const diffInDays = String(calcHours >0 ? calcHours : 0);
  
  const newDays = String(diffInDays).length === 1 ? "0"+ diffInDays : diffInDays
  const daysText = Number(diffInDays) > 1 ? "Days" : "Day"

  const onClickCTAHandler = () => {

    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.ConnectModalScholarship,
        modalData: { associatedPrograms, isLandingPage: true, isNewLeadForm: true ,isTestScholarship:true },
      },
    });


    setTimeout(()=>{

      pushToDataLayer({
        event: "test_initiate",
        cta_text: "Apply_Now",
        section_name: "strip_text_ui",
        page_type: getGlobalStateValue("pageType"),
        page_url: window.location.href,
      });

      updateStateSession({
        parentSection: "strip_text_ui",
      })


    },1500)
  }


  const scrollToLeadForm = ()=> {
    document.getElementById(isScrollableID)?.scrollIntoView({
      block: "start",
    });
  }
  return (
    <div className="container">
      <button
        onClick={isScrollable?scrollToLeadForm:onClickCTAHandler}
      className={styles.stripContainerNew}
      >
      <div
        dangerouslySetInnerHTML={{
          __html: htmlContent
          .replaceAll( "{days}", newDays)
          .replaceAll("{daysText}", daysText)
        }}
      />
      </button>
    </div>
  );
};

export default StripDataNew;
